import { useMemo, type ReactNode } from 'react';
import { TrackingContext } from './tracking-context';
import { getTrackingService } from './tracking-instance';
import type { TrackingService } from './tracking-service';

interface TrackingProviderProps {
  children: ReactNode;
  service?: TrackingService;
}

export function TrackingProvider({ service, children }: TrackingProviderProps) {
  const trackingService = useMemo(() => service ?? getTrackingService(), [service]);

  return <TrackingContext.Provider value={trackingService}>{children}</TrackingContext.Provider>;
}
